import { render, staticRenderFns } from "./TeacherNotWorkingHours.vue?vue&type=template&id=7f036e70&"
import script from "./TeacherNotWorkingHours.vue?vue&type=script&lang=js&"
export * from "./TeacherNotWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports